import { render, staticRenderFns } from "./Unsupported.vue?vue&type=template&id=2683ea67&scoped=true&"
import script from "./Unsupported.vue?vue&type=script&lang=js&"
export * from "./Unsupported.vue?vue&type=script&lang=js&"
import style0 from "./Unsupported.vue?vue&type=style&index=0&id=2683ea67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683ea67",
  null
  
)

export default component.exports